import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Welcome back");
            nav("/dashboard");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <div className="mx-auto grid min-h-[calc(100vh-4rem)] max-w-7xl grid-cols-1 items-center gap-12 px-6 py-16 md:grid-cols-2">
            <div className="hidden md:block">
                <div className="overline mb-4 text-primary">Welcome back</div>
                <h1 className="font-display text-5xl font-semibold tracking-tight">Log in to your prep vault.</h1>
                <p className="mt-4 max-w-md text-muted-foreground">Pick up where you left off. Your practice streak is waiting.</p>
            </div>
            <form onSubmit={submit} className="mx-auto w-full max-w-md border border-border bg-card p-8" data-testid="login-form">
                <h2 className="font-display text-2xl font-semibold">Sign in</h2>
                <div className="mt-6 space-y-4">
                    <div>
                        <Label htmlFor="email">Email</Label>
                        <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
                    </div>
                    <div>
                        <Label htmlFor="password">Password</Label>
                        <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
                    </div>
                    <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground hover:bg-primary/90" data-testid="login-submit">
                        {loading ? "Signing in…" : "Sign in"}
                    </Button>
                </div>
                <p className="mt-6 text-sm text-muted-foreground">
                    No account yet? <Link to="/register" className="text-primary" data-testid="login-to-register">Create one</Link>
                </p>
            </form>
        </div>
    );
}
